// Client-side mirror of the backend /api/auth/change-password rule:
// at least 8 characters, at least 1 letter and at least 1 number.

export const PASSWORD_MIN_LENGTH = 8;

const HAS_LETTER_REGEX = /[A-Za-z]/;
const HAS_NUMBER_REGEX = /\d/;

/**
 * Validate a candidate password against the backend password rule.
 *
 * @returns a user-facing error message, or null when the password is valid.
 */
export function getPasswordRuleError(password: string): string | null {
  if (!password || password.length < PASSWORD_MIN_LENGTH) {
    return `Password must be at least ${PASSWORD_MIN_LENGTH} characters long.`;
  }
  if (!HAS_LETTER_REGEX.test(password)) {
    return 'Password must contain at least one letter.';
  }
  if (!HAS_NUMBER_REGEX.test(password)) {
    return 'Password must contain at least one number.';
  }
  return null;
}
